import { render } from "./DesignTemplates.vue?vue&type=template&id=b5c4548e&scoped=true"
import script from "./DesignTemplates.vue?vue&type=script&lang=js"
export * from "./DesignTemplates.vue?vue&type=script&lang=js"

import "./DesignTemplates.vue?vue&type=style&index=0&id=b5c4548e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5c4548e"]])

export default __exports__